import { defineAsyncComponent } from 'vue'
export default {
  footer: defineAsyncComponent(() => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/layouts/Footer.vue").then(m => m.default || m)),
  header: defineAsyncComponent(() => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/layouts/Header.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/builds/jctrans/tech/front/dashboard/serverside/server-era-h5-front/app/layouts/default.vue").then(m => m.default || m))
}